<form [formGroup]="uitlegFormGroup">
    <ng-container formGroupName="aangever">
        <ng-container *ngFor="let propertyName of propertyNamesToCheck; let i = index">
            <div class="left"
                                          *ngIf="getPropertyValue(propertyName) !== null && getPropertyValue(propertyName) !== 0 ">
                <div class="row" *ngIf="i < 20">
                    <ng-container>
                        <div class="col col-1 pt-1">
                            <p> {{ getLabelText(propertyName) }}</p>
                        </div>
                    </ng-container>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [formControlName]="propertyName"
                                [id]="propertyName"
                                class="custom-input-150"
                                [decimals]="0"
                                align="right"
                                placeholder="0"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
                <div class="row" *ngIf="i === 20">
                    <ng-container>
                        <div class="col col-1 pt-1">
                            <p> {{ getLabelText(propertyName) }}</p>
                        </div>
                    </ng-container>
                    <div class="col-2"></div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [formControlName]="propertyName"
                                [id]="propertyName"
                                class="me-1 custom-input-150 bold"
                                [decimals]="0"
                                align="right"
                                placeholder="0"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
        </ng-container>

    </ng-container>
</form>
